// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

/**
 * Treatment Plan + Vet Internal Notes for a pet that has NO chart data yet.
 *
 * With readings, both panels live in PetGlucoseDetailPanel's "Part 5" column
 * beside the AGP chart. That whole panel is gated on a chart-eligible device,
 * so a newly diagnosed patient (no sensor yet), a sensor still waiting for its
 * first sync, or a pet between sensors had no way to receive a plan — and
 * that is exactly when a vet writes one. PetShow renders this card in the
 * no-device branch instead; same components, same save paths.
 */
import { Card, CardContent, Divider, Grid } from '@mui/material'
import { useTranslate } from 'react-admin'
import { ErrorBoundary } from '../../components/ErrorBoundary'
import { TreatmentPlanPanel } from './TreatmentPlanPanel'
import { VetNotesPanel } from './VetNotesPanel'

export const PetTreatmentCard = ({ petId }: { petId: string | number }) => {
  const translate = useTranslate()
  return (
    <Card sx={{ mt: 2 }} data-testid="pet-treatment-card">
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={7}>
            <ErrorBoundary
              componentName={translate('pos.error_boundary.names.treatment_plan')}
              compact
            >
              <TreatmentPlanPanel petId={petId} />
            </ErrorBoundary>
          </Grid>
          <Grid item xs={12} md={5}>
            <Divider sx={{ my: 2, display: { md: 'none' } }} />
            <VetNotesPanel petId={petId} maxHeight={350} showAddForm={true} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
